var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSortDesc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15852_23841)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_15852_23841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 6.46652C5.33333 5.91423 4.88562 5.46652 4.33333 5.46652C3.78105 5.46652 3.33333 5.91424 3.33333 6.46652L3.33333 16.0523L1.70711 14.4261C1.31658 14.0356 0.683417 14.0356 0.292893 14.4261C-0.0976311 14.8166 -0.0976311 15.4498 0.292893 15.8403L3.62623 19.1736C4.01675 19.5642 4.64992 19.5642 5.04044 19.1736L8.37377 15.8403C8.7643 15.4498 8.7643 14.8166 8.37377 14.4261C7.98325 14.0356 7.35008 14.0356 6.95956 14.4261L5.33333 16.0523L5.33333 6.46652Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8 5.84191C10.8 5.26637 11.2262 4.7998 11.7519 4.7998L23.0481 4.7998C23.5738 4.7998 24 5.26637 24 5.84191C24 6.41745 23.5738 6.88402 23.0481 6.88402H11.7519C11.2262 6.88402 10.8 6.41745 10.8 5.84191Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8 16.9577C10.8 16.3822 11.2262 15.9156 11.7519 15.9156H14.7288C15.2546 15.9156 15.6808 16.3822 15.6808 16.9577C15.6808 17.5332 15.2546 17.9998 14.7288 17.9998H11.7519C11.2262 17.9998 10.8 17.5332 10.8 16.9577Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7519 10.3577C11.2262 10.3577 10.8 10.8243 10.8 11.3998C10.8 11.9753 11.2262 12.4419 11.7519 12.4419H19.8058C20.3315 12.4419 20.7577 11.9753 20.7577 11.3998C20.7577 10.8243 20.3315 10.3577 19.8058 10.3577H11.7519Z",
    fill: "#71869D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15852_23841"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_15852_23841"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSortDesc);
export default __webpack_public_path__ + "static/media/iconSortDesc.dc5fcfdf4ba48742d3fc0619cc2e491d.svg";
export { ForwardRef as ReactComponent };